import React from 'react';

class SingleDataset extends React.Component {
    constructor(props){
        super(props)
    }

    render () {
        return (
            <div>
                <hr></hr>
                <div style={{"display":"flex"}}>
                    <span style={{"margin":"10px","borderBlockColor":"black"}}>
                        <img src={this.props.rootDir + '/' + this.props.data['name'] + this.props.data['thumbnail']}
                             alt={this.props.rootDir + '/' + this.props.data['name'] + this.props.data['thumbnail']}/>
                    </span>
                    <span style={{"marginTop":"20px","marginLeft":"20px"}}>
                        <a href="" onClick={()=> this.props.history.push('/DatasetPage?name='+this.props.data['name'])}><h4>{this.props.data['name']}</h4> </a>
                        
                        <p>{this.props.data["description"]}</p>
                        <a href={this.props.data["url"]} >Credits: {this.props.data["author"]}</a>
                    </span>
                </div>
            </div>
        ) 
    }
}

export default SingleDataset;